import React, { useContext, useEffect, useState } from 'react'
import { NavigationContext } from '../../context/navigation-context'
import fetchHook from '../../hooks/fetchMSSQL-hook'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import formHook from '../../hooks/form-hook'
import { LangContext } from '../../context/lang-context'
import NoResults from '../../components/NoResults/NoResults'
import RouteForm from '../../components/Modals/RouteForm'
import { NotificationManager } from 'react-notifications'
import SearchFilter from "../../components/Filter/SearchFilter"

export default function Routes({setType, type}) {

const [routes, setRoutes] = useState([])
const { setHeaderData } = useContext(NavigationContext)
const [windowHeight, setWindowHeight] = useState(window.innerHeight)
const {fetchMssqlApi} = fetchHook()
const {form, openForm, closeForm} = formHook()
const {TRL_Pack} = useContext(LangContext)

  const defaultFilter = {
    page: 1,
    rowsPerPage: 100,
    isActive: "true",
    sortBy: "none",
  };

  const [filter, setFilter] = useState(defaultFilter);
    const [settingsFilter, setSettingsFilter] = useState({
      saveFilters: true,
      autoLoading: true,
      additionalFilter: true,
      flatView: false,
      rowsPerPage: 50,
    });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    Name: "ASC",
    LocationsCount: "DESC",
    IsActive: "DESC",
  };

  const getBoolValue = value => (
    value === true || value === 1 || value === "1" || value === "true"
  )

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getRoutes(next);
  };

const getRoutes = (f = filter) => {
    const isActive = typeof f === "object" ? f?.isActive : f;
    const sortBy = typeof f === "object" ? f?.sortBy : null;

    let url = `routes/?IsActive=${isActive}`;
    if (sortBy && sortBy !== "none") {
        url += `&sortBy=${encodeURIComponent(sortBy)}`;
    }

    fetchMssqlApi(url, {}, res => {
        setRoutes(res || [])
    })
}

const getCheckboxFromBool = value => (
    <div className='d-flex justify-content-center align-items-center'>
        <input
            type='checkbox'
            checked={getBoolValue(value)}
            readOnly
        />
    </div>
)

const handleSubmit = (evt, data, setData, locations) => {
    evt.preventDefault()

    const routeName = evt.target.elements.name.value.trim()
    const routeId = Number(form)
    const isActive = document.querySelector("#isActive")
    const routeIsActive = getBoolValue(isActive?.value ?? data.IsActive) ? 1 : 0

    const nameExists = routes
        .filter(route => Number(route.RouteId) !== routeId)
        .some(route => String(route.Name || "").trim().toLowerCase() === routeName.toLowerCase())

    if (nameExists) {
        NotificationManager.error("Taka nazwa już istnieje")
        setData(prev => ({...prev, Name: ""}))
        return
    }

    const payload = {
        LocationsJSON: locations,
        Name: routeName,
    }

    if (form === "new") {
        fetchMssqlApi('route', {method: "POST", data: payload}, () => {
            getRoutes(filter)
            closeForm()
        })
    } else {
        fetchMssqlApi(`route/${form}`, {
            method: "PUT",
            data: {
                ...payload,
                IsActive: routeIsActive,
            }
        }, () => {
            getRoutes(filter)
            closeForm()
        })
    }
}

useEffect(() => {
    setHeaderData({text: "Trasy"})
    getRoutes(defaultFilter)
}, [])

useEffect(() => {
    const handleResize = () => {
    setWindowHeight(window.innerHeight)

    const screenHeight = window.innerHeight
    const reservedSpace = 350
    const visibleRows = Math.floor((screenHeight - reservedSpace) / 40)

    setFilter(prev => ({
        ...prev,
        rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
    }))
    }

    window.addEventListener("resize", handleResize)
    handleResize()

    return () => window.removeEventListener("resize", handleResize)
    }, [])

    const filtered = routes.filter(route => {
        const isActive = getBoolValue(route.IsActive)

        if (filter.isActive === "true") return isActive
        if (filter.isActive === "false") return !isActive
        return true
    })

    return (
        <div>
            <div>
                <ul className='nav nav-tabs machine-tabs mb-3'>
                <li className="nav-item">
                    <Link to='/machinelocations'>
                    <button
                    className={`nav-link btn ${type === "Locations"  && 'active'}`}
                    tabIndex="0">
                        Lokalizacje
                    </button>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link to='/routes'>
                    <button
                    className={`nav-link btn active`}
                    tabIndex="0">
                        Trasy
                    </button>
                    </Link>
                </li>

            </ul>
            </div>
            <SearchFilter
                filterName="routes"
                defaultFilter={defaultFilter}
                onFilterChange={(f) => setFilter(prev => ({ ...prev, ...f }))}
                onSettingsChange={(s) => setSettingsFilter(prev => ({ ...prev, ...s }))}
                search={getRoutes}
                loading={false}
                totalCount={filtered.length}
                dataList={routes}
                forNow
            />
            <div
                className="card-body overflow-auto custom-scroll"
                    style={{
                        maxHeight: `${windowHeight - 230}px`,
                        overflowY: "auto",
                    }}
            >
            {filtered.length ? (
                <div className='card'>
                <div className='card-header'>
                <button
                    className="d-block btn text-nowrap btn-outline-secondary text-decoration-none ml-auto my-2 mr-1"
                    onClick={openForm()}
                >
                    <i className="fas fa-plus" />
                    {TRL_Pack.locations.addProductButton}
                </button>
            </div>
                <table className='table table-striped border'>
                    <thead>
                        <tr className='text-center headers-color'>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("Name")}
                            >
                                Trasa{arrow("Name")}
                            </th>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("LocationsCount")}
                            >
                                Ilość lokalizacji{arrow("LocationsCount")}
                            </th>
                            <th
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("IsActive")}
                            >
                                Aktywna{arrow("IsActive")}
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered
                        .slice(
                            (filter.page - 1) * rowsPerPage,
                            filter.page * rowsPerPage)
                            .map(trace => (
                            <tr key={trace.RouteId} className='text-center'>
                                <td>
                                    {trace.Name}
                                </td>
                                <td>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        {trace.LocationsCount}
                                    </div>
                                </td>
                                <td>
                                    {getCheckboxFromBool(trace.IsActive)}
                                </td>
                                <td className='d-flex justify-content-end mb-2 mt-2 border-0'>
                                    <button className="btn btn-outline-primary btn-sm "
                                            onClick={openForm(trace.RouteId)}
                                            >
                                        Edytuj
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            ) : (
                <NoResults buttonText={TRL_Pack.locations.addProduct} onClick={openForm()} />
            )}
            </div>
            { form && (
                <RouteForm
                    traceData={routes.find(route => route.RouteId === form)}
                    handleClose={closeForm}
                    handleSubmit={handleSubmit}
                />
            )}
        </div>
    )
}